<template>
  <footer class="footer-component">
    <div class="base-container">
      <div class="footer-top-wrapper">
        <a href="/" class="footer-logo-link">
          <img src="../../assets/images/img/artemisads-logo.svg" loading="lazy" alt="Brand Logo" />
        </a>
        <div class="footer-link-column" ref="foorterPopover">
          <p>Contact Us:</p>
          <a-popover :get-popup-container="() => $refs.foorterPopover">
            <template #content>
              <img src="../../assets/images/social-media-qrcode/wechat.png" alt="Wechat QR Code" />
            </template>
            <span class="wechat"></span>
          </a-popover>
          <a-popover :get-popup-container="() => $refs.foorterPopover">
            <template #content>
              <img src="../../assets/images/social-media-qrcode/whatsapp.png" alt="whatsapp QR Code" />
            </template>
            <span class="whatsapp"></span>
          </a-popover>
          <a-popover :get-popup-container="() => $refs.foorterPopover">
            <template #content>
              <img src="../../assets/images/social-media-qrcode/lark.png" alt="Lark QR Code" />
            </template>
            <span class="lark"></span>
          </a-popover>
          <a-popover :get-popup-container="() => $refs.foorterPopover">
            <template #content>
              <img src="../../assets/images/social-media-qrcode/slack.png" alt="Slack QR Code" />
            </template>
            <span class="slack"></span>
          </a-popover>
        </div>
      </div>
      <div class="footer-bottom-wrapper">Copyright © 2024ArtemisAds</div>
    </div>
  </footer>
</template>
<script setup>
const props = defineProps(['pageType'])
</script>

<style class="less">
.ant-popover {
  .ant-popover-arrow-content:before {
    bottom: 0;
    width: 16px;
    height: 8px;
    position: absolute;
    inset-inline-start: 0;
    clip-path: polygon(1.6568542494923806px 100%,
        50% 1.6568542494923806px,
        14.34314575050762px 100%,
        1.6568542494923806px 100%);
    clip-path: path('M 0 8 A 4 4 0 0 0 2.82842712474619 6.82842712474619 L 6.585786437626905 3.0710678118654755 A 2 2 0 0 1 9.414213562373096 3.0710678118654755 L 13.17157287525381 6.82842712474619 A 4 4 0 0 0 16 8 Z'
      );
    content: '';
    background: #fff;
  }

  .ant-popover-arrow-content:after {
    content: '';
    position: absolute;
    width: 8.970562748477143px;
    height: 8.970562748477143px;
    bottom: 0;
    inset-inline: 0;
    margin: auto;
    border-radius: 0 0 2px 0;
    transform: translateY(50%) rotate(-135deg);
    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.1);
    z-index: 0;
    background: transparent;
  }

  .ant-popover-inner {
    padding: 12px;
  }
}
</style>

<style lang="less" scoped>
.footer-component {
  padding: 0 15px;
  background-color: #efeafc;
}

.base-container {
  width: 100%;
  max-width: 1296px;
  margin-left: auto;
  margin-right: auto;
}

.footer-top-wrapper {
  display: flex;
  padding: 42px 0;
  align-items: center;
  justify-content: space-between;
}

.footer-link-column {

  >p {
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    margin-right: 4px;
    display: inline-block;
    vertical-align: middle;
  }

  span {
    width: 36px;
    height: 36px;
    margin-left: 8px;
    display: inline-block;
    vertical-align: middle;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .wechat {
    background-image: url('/images/social-media-logo/wechat-default@2x.png');

    &:hover {
      background-image: url('/images/social-media-logo/wechat@2x.png');
    }
  }

  .whatsapp {
    background-image: url('/images/social-media-logo/whatsapp-default@2x.png');

    &:hover {
      background-image: url('/images/social-media-logo/whatsapp@2x.png');
    }
  }

  .lark {
    background-image: url('/images/social-media-logo/lark-default@2x.png');

    &:hover {
      background-image: url('/images/social-media-logo/lark@2x.png');
    }
  }

  .slack {
    background-image: url('/images/social-media-logo/slack-default@2x.png');

    &:hover {
      background-image: url('/images/social-media-logo/slack@2x.png');
    }
  }

  img {
    width: 108px;
  }

  :deep(.ant-popover-inner) {
    padding: 10px;
  }
}

.footer-bottom-wrapper {
  border-top: 1px solid #cecdd1;
  padding-top: 24px;
  padding-bottom: 24px;
}
</style>